import { useRef, useState } from 'react'

import { API, constructApiUrl } from '../../../api/apis.config'
import FilterDrawer from '../../../components/elements/drawers/filter-drawer'
import DynamicDataTable, { DynamicTableRef } from '../../../components/elements/dynamic-table'
import { countFilters } from '../../../components/elements/dynamic-table/utils/countFilters'
import withPeriods, { WithPeriodsProps } from '../../../components/hoc/with-periods'
import { OlTeflPricesFilter } from '../../../components/pages/ols/ol-tefl-prices/ol-tefl-prices-filter'
import useAuth from '../../../lib/hooks/use-auth'
import { useFilters } from '../../../lib/hooks/use-filters'
import { useModalManager } from '../../../lib/hooks/use-modal-manager'
import useTranslate from '../../../lib/hooks/use-translate'
import {
  OlTeflPrice,
  OlTeflPriceFilters
} from '../../../lib/types/models/ol/tefl-price/ol-tefl-price'
import { PeriodProperties } from '../../../lib/types/models/period/period.properties'
import {
  transformOlTeflPriceFiltersToUrl,
  transformUrlToOlTeflPriceFilters
} from '../../../lib/utils/filters-mapping/ol-tefl-price'
import { getTeflPriceColumns } from './utils'

const teflPricesInitialFilters: OlTeflPriceFilters = {}

const FeesTeflPricesListPage = ({ periods }: WithPeriodsProps) => {
  const tableRef = useRef<DynamicTableRef<OlTeflPrice>>(null)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const { user } = useAuth()
  const { t } = useTranslate()
  const { modalState, toggleModal, closeModel } = useModalManager<'filters'>(['filters'])

  const { selectedFilter, filter, onFilterChange, resetFilters, onSelectedFilterChange } =
    useFilters<OlTeflPriceFilters>({
      initialFilters: {
        ...teflPricesInitialFilters,
        periods: PeriodProperties.getCurrentYearPeriods(periods ?? []).map((period) => period.name)
      },
      options: { allowSearchParam: true },
      transformFilterToUrl: transformOlTeflPriceFiltersToUrl,
      transformUrlToFilter: transformUrlToOlTeflPriceFilters
    })

  if (!user?.ol?.id) return null
  return (
    <div>
      <DynamicDataTable<OlTeflPrice, OlTeflPriceFilters>
        ref={tableRef}
        onLoadingChange={setIsTableLoading}
        title={'TEFL fees'}
        isSearchable={false}
        permissions={{ delete: false }}
        columns={getTeflPriceColumns('FEES', t)}
        allowSearchParam
        endpoint={constructApiUrl(API.ols.getOlTeflPrices.url, { olId: user?.ol?.id })}
        filters={selectedFilter}
        filtersLength={countFilters(selectedFilter)}
        onFiltersClick={() => toggleModal('filters')}
      />

      {/* Filters Modal */}
      <FilterDrawer<OlTeflPriceFilters>
        isOpen={modalState.filters}
        selectedFilter={selectedFilter}
        isLoading={isTableLoading}
        onClose={() => closeModel('filters')}
        onReset={resetFilters}
        onApply={() => onSelectedFilterChange({ ...filter })}
        onFilterChange={onFilterChange}
      >
        <OlTeflPricesFilter filter={filter} onFilterChange={onFilterChange} />
      </FilterDrawer>
    </div>
  )
}

export default withPeriods(FeesTeflPricesListPage)
